export default class SenderLock {

  static get storageName () {
    return 'isStandAloneSendingLocked';
  }

  static isLocked() {
    return JSON.parse(localStorage.getItem(this.storageName));
  }

  static lockSending() {
    localStorage.setItem(this.storageName, true);
  }

  static unlockSending() {
    localStorage.setItem(this.storageName, false);
  }
}